import { render, staticRenderFns } from "./CustomerHubDevelopment.vue?vue&type=template&id=484ec07a&scoped=true"
import script from "./CustomerHubDevelopment.vue?vue&type=script&lang=js"
export * from "./CustomerHubDevelopment.vue?vue&type=script&lang=js"
import style0 from "./CustomerHubDevelopment.vue?vue&type=style&index=0&id=484ec07a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484ec07a",
  null
  
)

export default component.exports